import Vue from 'vue';
import Vuex from 'vuex';

import informationStep from './modules/informationStep';
import completeStep from './modules/completeStep';
import paymentStep from './modules/paymentStep';
import quoteStep from './modules/quoteStep';
import waterConsumptionStep from './modules/waterConsumptionStep';
import microcopy from './modules/microcopy';

import stepProgress from './modules/stepProgress';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        informationStep,
        completeStep,
        paymentStep,
        quoteStep,
        waterConsumptionStep, 
        stepProgress,
        microcopy,
    },
}) 